<template>
    <header-body class="header-body--basic">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </header-body>
</template>

<script>
import HeaderBody from "@/sets/styles/headers/header-body.vue";

export default {
    props: {},
    components: {
        HeaderBody,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.app--main .header:not(:hover, .scroll-active){
    .header-body--basic {
        background-color: transparent;
        ::v-deep{
            .logo a{
                background-image: url(/images/logo-light.svg);
            }
            .gnb__link:not(:hover, .gnb__item.active>.gnb__link){
                color: #fff !important;
            }
        }
    }
}
</style>
